<!-- Ejemplo de Banner de Notificación -->
@if (updateService.updateAvailable()) {
  <div class="update-banner">
    <p>¡Hay una nueva versión disponible!</p>
    <button
      (click)="updateService.activateUpdate()"
      [disabled]="updateService.isActivating()">
      {{ updateService.isActivating() ? 'Actualizando...' : 'Recargar ahora' }}
    </button>
  </div>
}

<router-outlet />
